const CallbackOptions = {
	onConnected: "onConnected",
	hello: "hello",
	assemblyUpdate: "AssemblyUpdated",
};

export default CallbackOptions;
